import { ProLayoutProps } from '@ant-design/pro-components';

const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  colorPrimary: '#6f42c1',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: false,
  fixSiderbar: true,
  colorWeak: false,
  title: 'Virtual Call Center',
  pwa: false,
  // logo: '/logo.svg',
  iconfontUrl: '',
  token: {
    // Premium theme tokens
    borderRadius: 12,
    colorBgLayout: '#f8faff',
    colorPrimary: '#6f42c1',
    boxShadow: '0 8px 16px rgba(0,0,0,0.05)',
  },
  title: 'Virtual Call Center',
  logo: '/logo.svg',
};

export default Settings;

